import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { applyActionCode } from 'firebase/auth';
import { auth } from '../services/firebase/config';
import placeholderImage from '../assets/images/placeholder.webp';
import '../styles/Auth.css';

const VerifyEmail: React.FC = () => {
  const [isVerifying, setIsVerifying] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extract the oobCode from URL parameters
    const queryParams = new URLSearchParams(location.search);
    let actionCode = queryParams.get('oobCode');
    
    // Fallback to check for other parameter names
    if (!actionCode) {
      actionCode = queryParams.get('code');
    }

    if (!actionCode) {
      setError('Invalid verification link. No verification code provided.');
      setIsVerifying(false);
      return;
    }

    // Verify the email
    applyActionCode(auth, actionCode)
      .then(() => {
        setIsVerified(true);
        setIsVerifying(false);
      })
      .catch((error: any) => {
        let errorMessage = 'Failed to verify email. The link may have expired.';
        if (error.code === 'auth/invalid-action-code') {
          errorMessage = 'Invalid verification link. The link may have expired or already been used.';
        }
        setError(errorMessage);
        setIsVerifying(false);
      });
  }, [location]);

  const handleContinue = () => {
    navigate('/gyms');
  };

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="auth-container">
      {/* Image section for desktop */}
      <div className="auth-banner">
        <img src={placeholderImage} alt="Monkey Time" />
      </div>
      
      <div className="auth-content">
        <div className="auth-card">
          <h2 className="auth-title">Email Verification</h2>
          
          {/* Image for mobile - shown under title */}
          <div className="mobile-auth-image">
            <img src={placeholderImage} alt="Monkey Time" />
          </div>
          
          {isVerifying && (
            <div className="verification-loading">
              <p>Verifying your email address...</p>
            </div>
          )}
          
          {!isVerifying && isVerified && (
            <div className="verification-success">
              <h3>Email Verified!</h3>
              <p>Your email has been successfully verified.</p>
              <button 
                onClick={handleContinue} 
                className="auth-button"
              >
                Go to Banana Cup
              </button>
            </div>
          )}
          
          {!isVerifying && !isVerified && (
            <div className="verification-failed">
              <h3>Verification Failed</h3>
              {error && <div className="auth-error">{error}</div>}
              <p>Please try logging in again or request a new verification email.</p>
              <button 
                onClick={handleGoToLogin} 
                className="auth-button"
              >
                Go to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;